import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ListsService } from 'src/app/_services';
import { Product, ShoppingListEntry } from 'src/app/_models';
import { ProductFormatOptionsModalComponent } from '../product-format-options-modal/product-format-options-modal.component';


declare const $ : any;

@Component({
  selector: 'app-add-to-list',
  templateUrl: './add-to-list.component.html',
  styleUrls: ['./add-to-list.component.css']
})

export class AddToListComponent implements OnInit {

  @Input() product : Product;
  @Input() formatOptionsModal: ProductFormatOptionsModalComponent;

  public add2ListForm: FormGroup;
  public add2NewListForm: FormGroup;
  public f1submitted = false;
  public f2submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastr : ToastrService,
    private translate : TranslateService,
    public listss : ListsService
  ) { }

  ngOnInit() {

    this.add2ListForm = this.formBuilder.group({
      listid: ['', Validators.required],
    });

    this.add2NewListForm = this.formBuilder.group({
      listName: ['', Validators.required]
    });

    
    this.setFocusedList();
 
  }

  
  get f1() { 
    return this.add2ListForm.controls; 
  }

  get f2() { 
    return this.add2NewListForm.controls; 
  }


  onAdd2List(){    
    this.f1submitted = true;
    this.f2submitted = false

    if (this.add2ListForm.invalid) {
      return ;
    }
    
    if (this.product.has_format){
      this.formatOptionsModal.setProduct (this.product);
      this.formatOptionsModal.listId = this.add2ListForm.controls.listid.value;
      $('#modal-format-options-product').modal('show');
    } else { 
      this.listss.addLine(this.add2ListForm.controls.listid.value, 0, this.product, 1).subscribe(result =>{
        this.f1submitted = false;
        this.f2submitted = false
      });   
    }
      
  }

  onAdd2NewList(){
    this.f1submitted = false
    this.f2submitted = true;

    if (this.add2NewListForm.invalid) {
      return ;
    }

    this.listss.add(this.add2NewListForm.controls.listName.value).subscribe( lisId => {

      this.f1submitted = false;
      this.f2submitted = false;    
      this.add2NewListForm.controls.listName.setValue('');

      if (this.product.has_format){
        this.formatOptionsModal.setProduct (this.product);
        this.formatOptionsModal.listId = lisId;
        $('#modal-format-options-product').modal('show');
      } else{
        this.listss.addLine(lisId, 0, this.product,1).subscribe(
          result => {
            this.setFocusedList();
          });
      }
    });
    
  }

  setFocusedList(){
    // this.add2ListForm.controls.listid.setValue(this.listss.userListsSubject.value.find(list => { 
    //   return list.focused; 
    // }).id);

    this.listss.userLists.subscribe(lists =>{
      if (lists){

        let list : ShoppingListEntry = lists.find(list => { 
          return list.focused; 
        });

        if (list){
          this.add2ListForm.controls.listid.setValue(list.id);   
        }

      }
    });

  }

}
